import axios from "../customize_axios"

export const getAllCustomer = async (token, page = 0) => {
    try {
      const response = await axios.get(`/api/users?page=${page}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      // console.log("Fetched all customers:", response);
      return response.data;
    } catch (error) {
      console.log("Error fetching all customer:", error);
      throw error; 
    }
  };

export const getCustomersByStatus = async (token, status, page) => {
  try {
      const response = await axios.get(
          `/api/users/status?isBlocked=${status}&page=${page}`,
          {
              headers: {
                  Authorization: `Bearer ${token}`
              }
          }
      )
      return response.data
  } 
  catch (error) {
      console.log("getCustomersByStatus", error.response ? error.response.data : error.message)    
  }
}

  export const blockCustomer = async (token, email) => {
    if (!token) {
      throw new Error("Token is missing. Please authenticate.");
    }
    try {
      const response = await axios.post(
        `/api/user/block?email=${email}`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(`Block customer ${email} successful:`, response.data);
      return response;
    } catch (error) {
      console.error("Error block customer:", error.response?.data || error.message);
      throw error; 
    }
  };
  

  export const unBlockCustomer = async (token, email) => {
    try {
      const response = await axios.post(`/api/user/unblock?email=${email}`, {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      console.log(`block customer ${email} :`, response);
      return response;
    } catch (error) {
      console.error("Error block customer:", error.response?.data || error.message);
      throw error; 
    }
  };
  
  export const searchCustomer = async (token, search, page) => {
    try {
      const response = await axios.get(
        `api/users/search?keyword=${search}&page=${page}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      console.log(`search customer :`, response);
      return response.data;
    } catch (error) {
      console.error("error search customer:", error.response?.data || error.message)
    }
  }
  